import { axiosWithAuth } from "helpers";

export const chargebacksDetailsService = {
	getMerchantInfo,
	getRecommendationInfo,
	updateRecommendationInfo,
	getChargebackInfo,
	updateChargebackInfo,
	downloadChargebackReport,
	completeChargeback,
};

const API_URL = process.env.REACT_APP_API_URL;

function getMerchantInfo({ chargebackId }: { chargebackId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/merchant_info`,
	};

	return axiosWithAuth(options);
}

function getRecommendationInfo({ chargebackId }: { chargebackId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/recommendation`,
	};

	return axiosWithAuth(options);
}

function updateRecommendationInfo(chargebackId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/recommendation`,
	};

	return axiosWithAuth(options);
}

function getChargebackInfo({ chargebackId }: { chargebackId: string }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/reason_for_review`,
	};

	return axiosWithAuth(options);
}

function updateChargebackInfo(chargebackId, model) {
	const options = {
		method: "POST",
		data: model,
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/reason_for_review`,
	};

	return axiosWithAuth(options);
}

function downloadChargebackReport(chargebackId, token) {
	const url = `${API_URL}/api/chargeback_reviews/${chargebackId}/report?token=${token}`;
	var link = document.createElement("a");
	link.href = url;
	link.click();
}

function completeChargeback(chargebackId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/chargeback_reviews/${chargebackId}/complete`,
	};

	return axiosWithAuth(options);
}
